"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _merge2 = _interopRequireDefault(require("lodash/merge"));
var _react = _interopRequireDefault(require("react"));
var _reactResponsiveModal = require("react-responsive-modal");
require("react-responsive-modal/styles.css");
var _CloseIcon = require("./components/CloseIcon");
var _excluded = ["center", "styles", "children"];
var ResponsiveModal = function ResponsiveModal(props) {
  var _props$center = props.center,
    center = _props$center === void 0 ? true : _props$center,
    styles = props.styles,
    children = props.children,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var defaultStyles = {
    root: {
      // необходимо, чтобы перебить z-index шапки в отелях
      zIndex: 11000
    },
    overlay: {
      padding: 0,
      background: 'rgba(145,148,153,.5)',
      // необходимо, чтобы перебить z-index шапки в отелях
      zIndex: 11000
    },
    modal: {
      overflow: 'visible',
      margin: 'auto'
    },
    closeButton: {
      top: '16px',
      right: '16px',
      color: '#919499',
      outline: 'none'
    }
  };
  var combinedStyles = (0, _merge2["default"])(defaultStyles, styles);
  return /*#__PURE__*/_react["default"].createElement(_reactResponsiveModal.Modal, (0, _extends2["default"])({
    center: center,
    closeIcon: /*#__PURE__*/_react["default"].createElement(_CloseIcon.CloseIcon, null)
  }, rest, {
    styles: combinedStyles
  }), children);
};
var _default = exports["default"] = ResponsiveModal;